var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FF6843"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4359_38976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51758 9.06532V16.9305C8.51812 17.2059 8.59104 17.4765 8.72903 17.7149C8.86702 17.9533 9.06524 18.1513 9.30383 18.2891C9.54243 18.4268 9.81302 18.4994 10.0885 18.4996C10.364 18.4999 10.6347 18.4277 10.8735 18.2904L17.6992 14.3573C17.9375 14.2198 18.1354 14.0219 18.273 13.7836C18.4106 13.5453 18.483 13.275 18.483 12.9998C18.483 12.7247 18.4106 12.4543 18.273 12.216C18.1354 11.9777 17.9375 11.7799 17.6992 11.6423L10.8735 7.70926C10.635 7.5721 10.3646 7.49994 10.0895 7.5C9.81431 7.50006 9.54398 7.57233 9.3055 7.7096C9.06701 7.84687 8.86873 8.04432 8.73047 8.28222C8.5922 8.52013 8.51879 8.79016 8.51758 9.06532Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4359_38976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.4ef8c2bcfbe4f9907dc6a3879fb55aed.svg";
export { ForwardRef as ReactComponent };